import { render, staticRenderFns } from "./ColorDisplay.vue?vue&type=template&id=604e3610&scoped=true"
import script from "./ColorDisplay.vue?vue&type=script&lang=js"
export * from "./ColorDisplay.vue?vue&type=script&lang=js"
import style0 from "./ColorDisplay.vue?vue&type=style&index=0&id=604e3610&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604e3610",
  null
  
)

export default component.exports